import React, { useContext } from "react";
import PropTypes from "prop-types";
// import styled from 'styled-components';

import { CrosswordContext } from "./context";

import Clue from "./Clue";

const directionCluesPropTypes = {
	/** direction of this list of clues ("across" or "down") */
	direction: PropTypes.string.isRequired,

	/** a label to use instead of the (English) default */
	label: PropTypes.string,
};

export default function DirectionClues({ direction, label }) {
	const { clues } = useContext(CrosswordContext);

	return (
		<div className="direction">
			{/* use something other than h3? */}
			<h3 className="header">{label || direction.toUpperCase()}</h3>
			{clues?.[direction].map(({ number, clue, complete, correct, completed, corrected, gameCompletion, attempted }) => (
				<Clue
					key={number}
					direction={direction}
					number={number}
					complete={complete}
					correct={correct}
					completed={completed}
					corrected={corrected}
					gameCompletion={gameCompletion}
					attempted={attempted}
				>
					{clue}
				</Clue>
			))}
		</div>
	);
}

DirectionClues.propTypes = directionCluesPropTypes;

DirectionClues.defaultProps = {
	label: undefined,
};
